import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ReactQuill from "react-quill";
import { IoArrowBackOutline } from "react-icons/io5";
import axios from "axios";
import { server_API } from "../config";
import { useSelector } from "react-redux";
import { selectCid } from "../features/companyid";
import { toast, ToastContainer } from 'react-toastify'
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import { ToastIcon } from "../components/TestOfferInitiation";
const SalaryProposal = () => {
  const cid = useSelector(selectCid);
  useEffect(() => {
    window.scrollTo(0, 0);
    axios
      .get(`${server_API}/v2/company/geturl/${cid}`)
      .then((response) => {
        console.log(response);
        setLogo(response.data.url);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const [templateType, setTemplateType] = useState([]);
  const [justification, setJustification] = useState("")

  const sendEmail = ()=>{
    toast.success("Document request email has been successfully sent to the candidate.",{icon:<ToastIcon/>})
  }
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");
  const [files, setFiles] = useState([]);
  const [logo, setLogo] = useState(null);
  const [sendTo, setSendTo] = useState("")
  const [proposal, setProposal] = useState([
    {
        "totalfixedpay":0,
        "variablepay":0,
        "esop":0,
        "esopvalue":0,
        "totalcompensation":0,
        "%increaseonctc":0,
        "%increaseontc":0
    },
    {
        "totalfixedpay":0,
        "variablepay":0,
        "esop":0,
        "esopvalue":0,
        "totalcompensation":0,
        "%increaseonctc":0,
        "%increaseontc":0
    },
  ])
  const [showGoBackModal, setGoBackModal] = useState(false)
  const [showCancelModal, setShowCancelModal] = useState(false)
  const handleChange=(index,e)=>{
    const newData = proposal.map((f, i) => {
        if (index === i) {
          return { ...f, [e.target.name]: e.target.value };
        }
        return f;
    });
    setProposal(newData)
  }
  return (
    <div className="bg-[#f0f4fc] min-h-screen">
         <ToastContainer></ToastContainer>
         {
            showGoBackModal &&
            <div className="popup-container">
                <div className="p-4 border shadow-xl rounded-lg bg-white">
                    <p className="font-semibold">Going back will not save your work as a draft. Do you still want to go back?</p>
                    <div className="flex items-center justify-between mt-5">
                        <button className="rounded-lg px-4 border-[#148EFF] border text-[#148EFF] bg-white py-2" onClick={()=>{setGoBackModal(false)}}>No, stay here</button>
                        <button className="rounded-lg bg-[#148EFF] px-4 py-2 text-white" >Yes, Go Back</button>
                    </div>
                </div>
            </div>
         }
         {
            showCancelModal &&
            <div className="popup-container">
                <div className="p-4 border shadow-xl rounded-lg bg-white">
                    <p className="font-semibold">If you cancel, your created email will not be saved as a draft. Do you still want to cancel?</p>
                    <div className="flex items-center justify-between mt-5">
                        <button className="rounded-lg px-4 border-[#148EFF] border text-[#148EFF] bg-white py-2" onClick={()=>{setShowCancelModal(false)}}>No, stay here</button>
                        <button className="rounded-lg bg-[#148EFF] px-4 py-2 text-white" >Yes, Cancel</button>
                    </div>
                </div>
            </div>
         }
      <div className="p-4 md:px-10 pt-5">
        <div className="flex gap-4 items-center">
          <Link to="/jobs/candidates">
            {" "}
            <IoArrowBackOutline className="w-7 cursor-pointer h-7 " />
          </Link>
          <p className="text-[28px] font-semibold">
            Salary Proposal Creation
          </p>
        </div>
        <div className=" rounded-xl mt-6 bg-white  shadow-2xl">
            <div className="flex">

          <div className="w-1/2 py-4 px-6">
            <p className="font-semibold">
              Email Template <span className="text-red-500">*</span>
            </p>
            <select
              value={templateType}
              onChange={(e) => {
                setTemplateType(e.target.value);
              }}
              className="border border-r-[30px]  px-1 py-2 rounded-lg mt-2 w-full"
            >
              <option value=""> </option>
              <option value="Sales">Sales</option>
              <option value="Engineering">Engineering</option>
              <option value="Design">Design</option>
              <option value="Marketing">Marketing</option>
              <option value="Finance">Finance</option>
            </select>

            <p className="font-semibold mt-4">
              Send To<span className="text-red-500">*</span>
            </p>
            <select
              value={sendTo}
              onChange={(e) => {
                setSendTo(e.target.value);
              }}
              className="border border-r-[30px]  px-1 py-2 rounded-lg mt-2 w-full"
            >
              <option value=""> </option>
              <option value="Sales">User 1</option>
              <option value="Engineering">User 2</option>
              <option value="Design">User 3</option>
              <option value="Marketing">User 4</option>
              <option value="Finance">User 5</option>
            </select>

            <div className="mt-5">
            <p className="font-semibold">
              Salary Proposal<span className="text-red-500">*</span>
            </p>
            <div className="rounded-lg border mt-2 p-4">
                <Table>
                    <Thead>
                        <Tr>
                            <Th className="w-1/3"></Th>
                            <Th className="text-right w-1/3 pr-2 font-semibold">Current</Th>
                            <Th className="font-semibold w-1/3 text-right">Proposed</Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                    <Tr>
                            <Td>Total Fixed Pay</Td>
                            <Td className="pr-2">
                                <input className="outline-none border px-2  py-2 w-full rounded-lg mt-2" name="totalfixedpay" value={proposal[0]["totalfixedpay"]} onChange={(e)=>{handleChange(0,e)}}></input>
                            </Td>
                            <Td>
                                <input className="outline-none border px-2 py-2 w-full rounded-lg mt-2" name="totalfixedpay" value={proposal[1]["totalfixedpay"]} onChange={(e)=>{handleChange(1,e)}}></input>
                            </Td>
                        </Tr>
                        <Tr>
                            <Td>Variable Pay</Td>
                            <Td className="pr-2">
                                <input className="outline-none border px-2  py-2 w-full rounded-lg mt-2" name="variablepay" value={proposal[0]["variablepay"]} onChange={(e)=>{handleChange(0,e)}}></input>
                            </Td>
                            <Td>
                                <input className="outline-none border px-2 py-2 w-full rounded-lg mt-2" name="variablepay" value={proposal[1]["variablepay"]} onChange={(e)=>{handleChange(1,e)}}></input>
                            </Td>
                        </Tr>

                        <Tr>
                            <Td>ESOP </Td>
                            <Td className="pr-2">
                                <input className="outline-none border px-2  py-2 w-full rounded-lg mt-2"name="esop" value={proposal[0]["esop"]} onChange={(e)=>{handleChange(0,e)}}></input>
                            </Td>
                            <Td>
                                <input className="outline-none border px-2 py-2 w-full rounded-lg mt-2" name="esop" value={proposal[1]["esop"]} onChange={(e)=>{handleChange(1,e)}}></input>
                            </Td>
                        </Tr>

                        <Tr>
                            <Td>ESOP Value</Td>
                            <Td className="pr-2">
                                <input className="outline-none border px-2  py-2 w-full rounded-lg mt-2" name="esopvalue" value={proposal[0]["esopvalue"]} onChange={(e)=>{handleChange(0,e)}}></input>
                            </Td>
                            <Td>
                                <input className="outline-none border px-2 py-2 w-full rounded-lg mt-2" name="esopvalue" value={proposal[1]["esopvalue"]} onChange={(e)=>{handleChange(1,e)}}></input>
                            </Td>
                        </Tr>

                        <Tr>
                            <Td></Td>
                            <Td className="pr-2">
                                <input className="outline-none border px-2  py-2 w-full rounded-lg mt-2" ></input>
                            </Td>
                            <Td>
                                <input className="outline-none border px-2 py-2 w-full rounded-lg mt-2" ></input>
                            </Td>
                        </Tr>

                        <Tr>
                            <Td className="font-semibold">Total Compensation</Td>
                            <Td className="pr-2">
                                <input className="outline-none border px-2  py-2 w-full rounded-lg mt-2" name="totalcompensation" value={proposal[0]["totalcompensation"]} onChange={(e)=>{handleChange(0,e)}}></input>
                            </Td>
                            <Td>
                                <input className="outline-none border px-2 py-2 w-full rounded-lg mt-2" name="totalcompensation" value={proposal[1]["totalcompensation"]} onChange={(e)=>{handleChange(1,e)}}></input>
                            </Td>
                        </Tr>

                        <Tr>
                            <Td>% increase on CTC</Td>
                            <Td className="pr-2">
                                <input className="outline-none border px-2  py-2 w-full rounded-lg mt-2" name="%increaseonctc" value={proposal[0]["%increaseonctc"]} onChange={(e)=>{handleChange(0,e)}}></input>
                            </Td>
                            <Td>
                                <input className="outline-none border px-2 py-2 w-full rounded-lg mt-2" name="%increaseonctc" value={proposal[1]["%increaseonctc"]} onChange={(e)=>{handleChange(1,e)}}></input>
                            </Td>
                        </Tr>

                        <Tr>
                            <Td>% increase on TC</Td>
                            <Td className="pr-2">
                                <input className="outline-none border px-2  py-2 w-full rounded-lg mt-2" name="%increaseontc" value={proposal[0]["%increaseontc"]} onChange={(e)=>{handleChange(0,e)}}></input>
                            </Td>
                            <Td>
                                <input className="outline-none border px-2 py-2 w-full rounded-lg mt-2" name="%increaseontc" value={proposal[1]["%increaseontc"]} onChange={(e)=>{handleChange(1,e)}}></input>
                            </Td>
                        </Tr>

                        
                    </Tbody>
                </Table>
            </div>
            </div>

            <div className="mt-5">
                <p className="font-semibold">Justification <span className="text-red-500">*</span></p>
                <textarea
                rows="4"
                className="outline-none border px-2 py-2 w-full rounded-lg mt-2"
                value={justification}
                onChange={(e)=>{setJustification(e.target.value)}}
                >

                </textarea>
            </div>
            
            <div className="mt-5 space-y-4">
              <p className="font-semibold">Email Customisation</p>
              <div>
                <p className="font-semibold">Subject</p>
                <input
                  onChange={(e) => {
                    setSubject(e.target.value);
                  }}
                  value={subject}
                  className=" outline-none border px-2 py-2 w-full rounded-lg mt-2"
                ></input>
              </div>

              <div>
                <p className="font-semibold">Email body</p>
                <ReactQuill
                  value={body}
                  onChange={setBody}
                  rows="5"
                  theme="snow"
                  className=" w-full rounded-xl py-2  mt-2"
                ></ReactQuill>
              </div>
              <div>
                <p>Attachments</p>
                <input
                  type="file"
                  onChange={(e) => {
                    setFiles(e.target.files);
                  }}
                  multiple
                ></input>
              </div>
            </div>
          </div>
          <div className="w-1/2 bg-[#f0f4fc] py-4 px-6">
            <p className="font-semibold">Email Preview</p>
            <div className="bg-white mt-3 rounded-lg p-4">
              {logo && <img src={logo} className="h-16"></img>}
              <ReactQuill
                value={body}
                rows="10"
                readOnly
                theme="bubble"
              ></ReactQuill>
            </div>
          </div>
        </div>
          <div className="bg-white text-right flex items-center justify-between rounded-b-lg px-6 py-4">
            <div className="flex items-center justify-start space-x-4">
                <button className="rounded-lg px-4 border-[#148EFF] border text-[#148EFF] bg-white py-2" onClick={()=>{setShowCancelModal(true)}}>Cancel</button>
                <button className="rounded-lg px-4 border-[#148EFF] border text-[#148EFF] bg-white py-2">Save as draft</button>
            </div>

            <button className="rounded-lg bg-[#148EFF] px-4 py-2 text-white" onClick={sendEmail}>Send Email</button>
          </div>
            </div>
      </div>
    </div>
  );
};

export default SalaryProposal;
